module.exports = __webpack_public_path__ + "387a7ce096678659eb89a63780e0eaf7.svg";